"use client";
import { CircularProgress, Grid } from "@mui/material";
import { VeBox, VeTypography } from "../../../mui";
import { RemoveIcon } from "./RemoveIcon";
import { useEffect, useState } from "react";

export const DocumentCard = ({
  fileKey,
  loading,
  DynamicImage,
  variables,
  item,
  formatFileSize,
  onRemove,
  mainIndex,
}: any) => {
  const [fileObjKey, setFileObjKey] = useState("");

  const { data: fileData, isSuccess } = variables.useQueryData({
    queryKey: ["get-file-s3-link"],
    endPoint: `/project/onboarding/files/signed-url?key=${
      item.fileKey
    }&bucket=${process.env.NEXT_PUBLIC_BUCKET_FILES!}`,
    enabled: fileObjKey?.length > 0,
  });

  const onDownloadClick = async () => {
    // Todo: Add download permission condition check
    if (!fileData) {
      console.error("No download URL available");
      return;
    }
    const newWindow = window.open(fileData?.url);
    if (newWindow) {
      newWindow.opener = null;
    }
    setFileObjKey("");
  };

  useEffect(() => {
    if (fileData) {
      onDownloadClick();
    }
  }, [fileData]);

  return (
    <Grid item sm={12} md={12} xs={12}>
      <VeBox
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        borderBottom={!mainIndex ? "0.5px solid #E8E8E8" : ""}
        alignItems={"center"}
        paddingTop="8px"
        paddingBottom="8px"
      >
        <VeBox
          display="flex"
          flexDirection="row"
          gap="8px"
          width="45%"
          alignItems={"center"}
        >
          {DynamicImage(
            variables?.getFileTypeImage(item?.type),
            "file",
            12,
            12,
          )}
          <VeTypography
            onClick={() => {
              setFileObjKey(item.fileKey);
            }}
            variant="label3Secondary"
            className="one_line_text_limit_right document_title"
            sx={{ cursor: "pointer" }}
          >
            {item?.title || "N/A"}
          </VeTypography>
        </VeBox>
        <VeTypography
          variant="label4Disabled"
          style={{ width: "30%", minWidth: "120px" }}
        >
          {item?.date || "N/A"}, {formatFileSize(item?.fileSize || 0)}
        </VeTypography>
        {loading && fileKey?.key === item.key ? (
          <VeBox
            display="flex"
            justifyContent="center"
            alignItems={"center"}
            marginRight={"5px"}
          >
            <CircularProgress size="10px" sx={{ color: "#646E83" }} />
          </VeBox>
        ) : (
          <VeBox
            display="flex"
            justifyContent="center"
            alignItems={"center"}
            onClick={() => {
              onRemove(item?.key);
            }}
          >
            <RemoveIcon defaultFill="#5F6368" hoverFill="#FF0000" />
          </VeBox>
        )}
      </VeBox>
    </Grid>
  );
};
